import React from "react";

const OrgViewSkeleton: React.FC = () => (
  <div className="bg-gray-100 h-full flex flex-col overflow-hidden animate-pulse">
    <div className="w-full mx-auto pt-6 px-4 sm:pt-12 sm:px-10 flex-shrink-0">
      {/* header */}
      <div className="mb-6">
        <div className="h-7 bg-gray-200 rounded w-48 mb-2" />
        <div className="h-4 bg-gray-200 rounded w-64" />
      </div>
      {/* tabs */}
      <div className="border-b border-gray-200">
        <div className="flex gap-8 pt-4 sm:pt-6">
          <div className="h-4 bg-gray-200 rounded w-24 mb-3" />
          <div className="h-4 bg-gray-200 rounded w-20 mb-3" />
        </div>
      </div>
    </div>
    {/* documents table */}
    <div className="flex-1 overflow-y-auto px-4 sm:px-10 pt-4 sm:pt-6 pb-8">
      <div className="bg-white rounded shadow overflow-x-auto">
        <table className="w-full">
          <thead className="border-b border-gray-200">
            <tr>
              <th className="px-4 py-3">
                <div className="h-3 bg-gray-200 rounded w-12" />
              </th>
              <th className="px-4 py-3 hidden md:table-cell">
                <div className="h-3 bg-gray-200 rounded w-14" />
              </th>
              <th className="px-4 py-3 hidden lg:table-cell">
                <div className="h-3 bg-gray-200 rounded w-12" />
              </th>
              <th className="px-4 py-3 hidden sm:table-cell">
                <div className="h-3 bg-gray-200 rounded w-10" />
              </th>
              <th className="px-4 py-3">
                <div className="h-3 bg-gray-200 rounded w-20" />
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {[...Array(8)].map((_, i) => (
              <tr key={i}>
                <td className="px-4 py-3">
                  <div className="h-4 bg-gray-200 rounded w-36" />
                </td>
                <td className="px-4 py-3 hidden md:table-cell">
                  <div className="h-4 bg-gray-200 rounded w-20" />
                </td>
                <td className="px-4 py-3 hidden lg:table-cell">
                  <div className="h-4 bg-gray-200 rounded w-24" />
                </td>
                <td className="px-4 py-3 hidden sm:table-cell">
                  <div className="h-4 bg-gray-200 rounded w-10" />
                </td>
                <td className="px-4 py-3">
                  <div className="h-4 bg-gray-200 rounded w-28" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default OrgViewSkeleton;
